import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  "Design Thinking and User Research",
  "Wireframing and Prototyping",
  "Visual Design Principles",
  "Usability Testing Techniques",
  "Tools like Figma and Adobe XD",
  "Responsive Design for Web and Mobile",
  "Portfolio Building and Case Studies",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 3 Months", desc: "Hands-on design training with expert mentors." },
  { title: "Portfolio Development",          desc: "Build a professional design portfolio." },
  { title: "Live Projects & Case Studies",   desc: "Work on real-world design challenges." },
  { title: "Monthly Assessment & Feedback",  desc: "Track and refine your design skills." },
  { title: "Certification & Job Support",    desc: "Industry-recognised certification on completion." },
];
const UIUX = () => (
  <CourseDetailTemplate title="UI/UX Design Certification Course"
    description="Become a certified UI/UX designer and create user-friendly interfaces! Learn design principles, prototyping, and usability testing. Enhance your career with hands-on projects and industry-relevant skills."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["Figma", "Adobe XD", "Prototyping", "User Research", "Design Thinking"]}
    programName="UI/UX Design Certification Course"
  />
);
export default UIUX;
